import { List } from "@mui/material";

import { NavItem } from "./Navigation.types";
import { NavigationItem } from "./components/item/NavigationItem";

interface Props {
  navigationItems: NavItem[];
  isCollapsed: boolean;
}

export function Navigation({ navigationItems, isCollapsed }: Props) {
  return (
    <List disablePadding sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      {navigationItems.map((navigationItem) => {
        return <NavigationItem key={navigationItem.path} navigationItem={navigationItem} isCollapsed={isCollapsed} />;
      })}
    </List>
  );
}
